<div *ngIf="hide_camera && !confirm">
    <h2 mat-dialog-title>
        <mat-icon>notification_important</mat-icon>
        Atención
    </h2>
    <div mat-dialog-content>
        <ul class="corrImg">
            <li>
                <img src="../../../../assets/images/incorrecto0.png" />
            </li>
            <li>
                <img src="../../../../assets/images/correcto1.png" />
            </li>
        </ul>
        <p class="disclaimer">En la foto debe aparecer claramente los <strong>bultos</strong> y el <strong>automóvil</strong> del cliente</p>
        <div class="error" *ngIf="camera_permission_error || camera_system_error">
            <p *ngIf="camera_permission_error">Los permisos de la cámara no han sido aceptados</p>
            <p *ngIf="camera_system_error">No se han encontrado cámaras disponibles</p>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button color="primary" class="btnlarge" [disabled]="isInitializing" (click)="activateCamera()">
            <mat-spinner diameter="20" *ngIf="isInitializing"></mat-spinner>
            <span *ngIf="!isInitializing">Buscar cámara y continuar</span>
        </button>
        <button mat-raised-button color="link" class="btnlarge" (click)="volver()">
            <mat-icon>arrow_back</mat-icon>Volver a las opciones
        </button>
    </div>
</div>

<div class="photoshot" *ngIf="!hide_camera && !confirm">
    <p>Saca una foto a los bultos del cliente</p>

    <webcam
        [trigger]="$trigger"
        [allowCameraSwitch]="allowCameraSwitch"
        [switchCamera]="$nextWebcam"
        [videoOptions]="videoOptions"
        (cameraSwitched)="cameraWasSwitched($event)"
        (initError)="handleInitError($event)"
        (imageCapture)="handleImage($event)"
        [width]="350"
        [height]="400">
    </webcam>

    <!-- Selector de cámaras disponibles
    <div class="camera-controls" *ngIf="multipleWebcamsAvailable">
        <mat-form-field>
            <mat-label>Seleccionar cámara</mat-label>
            <mat-select [(value)]="activeDeviceId" (selectionChange)="selectCamera($event.value)">
                <mat-option *ngFor="let device of availableVideoDevices" [value]="device.deviceId">
                    {{ device.label || ('Cámara ' + (availableVideoDevices.indexOf(device) + 1)) }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div> -->

    <button mat-raised-button color="primary" class="btnlarge" (click)="takePhoto()">
        <mat-icon>photo_camera</mat-icon> Tomar foto
    </button>
    <button mat-raised-button color="link" class="btnlarge" (click)="volver()">
        <mat-icon>arrow_back</mat-icon> Volver a opciones
    </button>
</div>

<div class="confirm" *ngIf="!hide_camera && confirm">
    <p>¿Firmar el pedido con esta foto?</p>
    <img [src]="preview_image" [width]="350" [height]="400">
    <div class="buttons">
        <button mat-raised-button class="bg-danger btnlarge" (click)="retry()">
            <mat-icon>replay</mat-icon> Reintentar
        </button>
        <button mat-raised-button class="bg-success btnlarge" (click)="firmar()">
            <mat-icon>check</mat-icon> Aceptar foto
        </button>
        <button mat-raised-button color="link" class="btnlarge" (click)="volver()">
            <mat-icon>arrow_back</mat-icon> Descartar y volver
        </button>
    </div>
</div>